import { render, staticRenderFns } from "./BatchTaskList.vue?vue&type=template&id=3faf20d6&scoped=true"
import script from "./BatchTaskList.vue?vue&type=script&lang=js"
export * from "./BatchTaskList.vue?vue&type=script&lang=js"
import style0 from "./BatchTaskList.vue?vue&type=style&index=0&id=3faf20d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faf20d6",
  null
  
)

export default component.exports